'use strict';
import * as $j_dev$002echeleb$002escalamigen$002epackage$0024package$0024$0024anon$00246 from "./dev.cheleb.scalamigen.package$package$$anon$6.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002epackage$0024package$0024$002dExtra$002dString$0024$0024anon$00241 from "./samples.package$package$-Extra-String$$anon$1.js";
var $p;
/** @constructor */
function $c_Lsamples_package$package$ExtraString$() {
  this.Mn = null;
  this.Mo = false;
}
export { $c_Lsamples_package$package$ExtraString$ as $c_Lsamples_package$package$ExtraString$ };
$p = $c_Lsamples_package$package$ExtraString$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_package$package$ExtraString$;
/** @constructor */
function $h_Lsamples_package$package$ExtraString$() {
}
export { $h_Lsamples_package$package$ExtraString$ as $h_Lsamples_package$package$ExtraString$ };
$h_Lsamples_package$package$ExtraString$.prototype = $p;
$p.V3 = (function() {
  if ((!this.Mo)) {
    this.Mn = new $j_dev$002echeleb$002escalamigen$002epackage$0024package$0024$0024anon$00246.$c_Ldev_cheleb_scalamigen_package$package$$anon$6(new $j_samples$002epackage$0024package$0024$002dExtra$002dString$0024$0024anon$00241.$c_Lsamples_package$package$ExtraString$$anon$1());
    this.Mo = true;
  }
  return this.Mn;
});
var $d_Lsamples_package$package$ExtraString$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_package$package$ExtraString$, "samples.package$package$ExtraString$", ({
  rj: 1
}));
export { $d_Lsamples_package$package$ExtraString$ as $d_Lsamples_package$package$ExtraString$ };
var $n_Lsamples_package$package$ExtraString$;
function $m_Lsamples_package$package$ExtraString$() {
  if ((!$n_Lsamples_package$package$ExtraString$)) {
    $n_Lsamples_package$package$ExtraString$ = new $c_Lsamples_package$package$ExtraString$();
  }
  return $n_Lsamples_package$package$ExtraString$;
}
export { $m_Lsamples_package$package$ExtraString$ as $m_Lsamples_package$package$ExtraString$ };
